<template>
  <div class="folders-list" v-bind:class="{ inner: isInnerList }">
    <div class="individual-folder" v-if="!isInnerList">
        <icon name="folder-o" class="text-primary" style="vertical-align: middle;"></icon>
        <a @click="setSelectedFolder(topLevel)"
           v-bind:class="{ active: isSelectedFolder(topLevel), disabled: isCurrentFolder(topLevel) }">
          (Top Level)
        </a>
      </div>
    <div v-for="folder in folders">
      <div class="individual-folder">
        <icon name="folder-o" class="text-primary" style="vertical-align: middle;"></icon>
        <a @click="setSelectedFolder(folder)"
           v-bind:class="{ active: isSelectedFolder(folder), disabled: isCurrentFolder(folder) }">
          {{folder.name}}
        </a>
        <span class="expand-button" v-if="folder.has_descendant_folders && !isCurrentFolder(folder)" @click="toggle(folder)">
        <icon :name="folder.open ? 'minus-square-o' : 'plus-square-o'" style="vertical-align: middle;"></icon>
        </span>
      </div>
      <folders-list
        :currentFolder="currentFolder"
        :folders="folder.descendants"
        v-show="folder.open"
        v-if="folder.descendants"
        isInnerList="true">
      </folders-list>
    </div>
  </div>
</template>

<script>
  export default {
    data () {
      return {
        topLevel: {folder_id: null, name: 'Top Level'}
      }
    },
    name: 'folders-list',
    props: {
      currentFolder: null,
      folders: Array,
      isInnerList: false
    },
    computed: {
      currentProject () {
        return this.$store.state.currentProject
      },
      selectedFolder () {
        return this.$store.state.selectedFolder
      }
    },
    methods: {
      isCurrentFolder (folder) {
        return this.currentFolder && this.currentFolder.folder_id === folder.folder_id
      },
      isSelectedFolder (folder) {
        return folder === this.selectedFolder
      },
      toggle (folder) {
        folder.open = !folder.open
        if (folder.open === true) {
          this.getDescendants(folder)
        }
      },
      getDescendants (folder) {
        this.$http.get(
          `/api/folder/${folder.folder_id}/descendant?atlassian_project_id=${this.currentProject.id}`
        ).then(response => {
          // Using $set to be able to add a new property that wasn't there before, to get around a JS limitation
          // See https://vuejs.org/v2/guide/reactivity.html#Change-Detection-Caveats
          this.$set(folder, 'descendants', response.data.folders)
        }, response => {
          console.log('error')
        })
      },
      setSelectedFolder (folder) {
        this.$store.commit('setSelectedFolder', folder)
      }
    }
  }
</script>

<style>
  .active {
    font-weight: bold;
  }
  .folders-list {
    font-size: 14px;
  }
  .folders-list .inner {
    margin-left: 1.5em;
  }
  .folders-list a {
    cursor: pointer;
  }
  .folders-list a.disabled {
    opacity: 0.6; /* Real browsers */
    filter: alpha(opacity = 60); /* MSIE */
    cursor: not-allowed
  }
  .individual-folder.span .individual-folder a {
    vertical-align: middle;
  }
  .expand-button {
    cursor: pointer;
    /*vertical-align: middle;*/
  }
</style>



// WEBPACK FOOTER //
// FoldersList.vue?7183a9f0